import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import { IconEye, IconPower, IconTrash, IconX } from '../components/Icons';
import '../components/AdminUI.css';

export default function Customers() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [selected, setSelected] = useState(null);

  const load = () => axios.get('/customers', { params: { search, status, per_page: 50 } })
    .then((r) => setItems(r.data.data || []));

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [search, status]);

  const toggle = async (id) => { await axios.patch(`/customers/${id}/toggle-status`); load(); };
  const remove = async (id) => { if (!window.confirm('Supprimer ce client ?')) return; await axios.delete(`/customers/${id}`); load(); };
  const open = async (id) => { const r = await axios.get(`/customers/${id}`); setSelected(r.data); };

  return (
    <div className="admin-page">
      <div className="admin-toolbar">
        <input className="admin-input" placeholder="Recherche…" value={search} onChange={(e) => setSearch(e.target.value)} style={{ maxWidth: 300 }} />
        <select className="admin-select" value={status} onChange={(e) => setStatus(e.target.value)} style={{ maxWidth: 200 }}>
          <option value="">Tous statuts</option>
          <option value="active">Actifs</option>
          <option value="inactive">Inactifs</option>
        </select>
      </div>

      <div className="admin-card" style={{ padding: 0, overflow: 'auto' }}>
        <table className="admin-table">
          <thead><tr><th>Nom</th><th>Email</th><th>Téléphone</th><th>Commandes</th><th>Statut</th><th>Inscrit</th><th></th></tr></thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>{u.phone || '—'}</td>
                <td>{u.orders_count ?? 0}</td>
                <td><span className={`admin-pill ${u.status === 'active' ? 'green' : 'red'}`}>{u.status}</span></td>
                <td>{u.created_at ? new Date(u.created_at).toLocaleDateString('fr-FR') : ''}</td>
                <td>
                  <div className="admin-actions">
                    <button className="admin-icon-btn" title="Voir" aria-label="Voir" onClick={() => open(u.id)}>
                      <IconEye />
                    </button>
                    <button
                      className={`admin-icon-btn ${u.status === 'active' ? '' : 'is-success'}`}
                      title={u.status === 'active' ? 'Suspendre' : 'Activer'}
                      aria-label={u.status === 'active' ? 'Suspendre' : 'Activer'}
                      onClick={() => toggle(u.id)}
                    >
                      <IconPower />
                    </button>
                    <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(u.id)}>
                      <IconTrash />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="admin-card">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h3 style={{ margin: 0 }}>{selected.name}</h3>
            <button className="admin-icon-btn" title="Fermer" aria-label="Fermer" onClick={() => setSelected(null)}>
              <IconX />
            </button>
          </div>
          <div style={{ color: '#6b7280', fontSize: 13, marginTop: 4 }}>{selected.email} · {selected.phone || '—'}</div>
          <h4 style={{ marginTop: 18 }}>Commandes récentes</h4>
          {(selected.orders || []).length === 0 && <p style={{ color: '#6b7280' }}>Aucune commande.</p>}
          {(selected.orders || []).map((o) => (
            <div key={o.id} style={{ borderTop: '1px solid #f1f5f9', padding: '6px 0', fontSize: 14 }}>
              <code>{o.order_code}</code> · {o.total_price} MAD · {o.status} · {new Date(o.created_at).toLocaleString('fr-FR')}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
